import { Flex } from 'antd';
import styled from 'styled-components';

import { ExclamationCircleFilled } from '@ant-design/icons';

export const Wrapper = styled(Flex).attrs({
  vertical: true,
  align: 'center',
  justify: 'center',
  gap: 10,
})``;

export const ModalIcon = styled(ExclamationCircleFilled)`
  font-size: 64px;
  margin-bottom: 10px;
`;
